module.exports = __webpack_public_path__ + "static/img/15.62277d3b.jpg";